import styled from 'styled-components'

export {
	StyledClassroomCard as StyledBundleCard,
	StyledClassroomImage as StyledBundleImage,
	Badge,
	CardBody,
	Title,
	Instructor,
	InfoWrapper,
	SubjectWrapper,
	SubjectImage,
	Subject,
	CardButton,
} from '@Components/Cards/ClassroomCard/ClassroomCard.styled'

export { PriceRibbon, OldPrice } from '@Components/Cards/CourseCard/CourseCard.styled'

export const CoursesCount = styled.span`
	width: fit-content;
	font-size: 0.75rem;
	font-weight: 600;
	border-radius: 999px;
	padding: 0.125rem 0.625rem;
	background: #f0eefc;
	color: ${p => p.theme.colors.primary};
`
